import React from 'react';
import Modal from '@material-ui/core/Modal';
import CrossIcon from '@components/Icons/CrossIcon';
import { useStyles } from './styles';

export const ModalLayout = ({ open, handleClose, children }) => {
  const classes = useStyles();

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose(false)}
        BackdropProps={{ style: { backgroundColor: 'rgba(2, 7, 20, 70%)' } }}
      >
        <div className={classes.modalInner}>
          <div className={classes.iconWrapper} onClick={handleClose(false)}>
            <CrossIcon />
          </div>
          <div>{children}</div>
        </div>
      </Modal>
    </div>
  );
};
